<!-- <app-card  [padding]="30">
    <div class="layout horizontal space-between middle" style="color: #005a9e; width: 230px;">
        <app-icon [id]="iconId" border="circle" size="80"
                  [clickable]="true"
                  (click)="navigate()"></app-icon>
        <div class="layout vertical right middle"
                style="margin-inline-start: 8px; min-width: 80px;">
            <div style="font-size: 2rem; margin-top: 3px; margin-bottom: 3px;">{{counter}}</div>
            <div style="margin-top: 10px;"
            [ngStyle]="{'font-size': label.length>10 ? '1rem' : '1.2rem'}">{{label}}</div>
        </div>
    </div>
    <div *ngIf="caption" style="margin-top: 10px">{{caption}}</div>
</app-card> -->
<app-card  [padding]="24">
    <div class="layout horizontal space-between middle" style="color: #005a9e; width: 230px;">
        <app-icon [id]="iconId" border="circle" size="80"
                  [clickable]="true"
                  (click)="navigate()"></app-icon>
        <div class="layout vertical right middle"
             style="margin-inline-start: 8px; min-width: 80px;">
            <div style="font-size: x-large; margin-top: 3px; margin-bottom: 3px;">{{label}}</div>
            <div style="margin-top: 10px;"
                 [ngStyle]="{'font-size': caption.length>20 ? '0.8rem' : null}">
                {{caption}}</div>
        </div>
    </div>
    <!-- <div *ngIf="caption" style="margin-top: 10px">{{caption}}</div> -->
</app-card>
